import Markdown from 'react-markdown';

type HeadingMarkdownProps = {
    children: string;
    as?: 'h1' | 'h2' | 'h3';
};

export const HeadingMarkdown: React.FC<HeadingMarkdownProps> = ({ children, as = 'h1' }) => (
    <Markdown
        components={{ p: as }}
        allowedElements={[as, 'p', 'strong']}
        unwrapDisallowed
    >
        {children}
    </Markdown>
);
